import React, { useEffect } from "react";
import { useTheme } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Scroller from 'react-scroll';

const scroll = Scroller.scroller;

export default function ServerState({ serverState, localState, setLocalState, handleRefresh, handleClose }) {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        if (serverState.Message !== undefined && serverState.Message !== null && (serverState.Message.MessageTitle || serverState.Message.MessageText)) {
            const MySwal = withReactContent(Swal);

            setTimeout(
                function () {
                    MySwal.fire({
                        title: serverState.Message.MessageTitle,
                        html: serverState.Message.MessageText,
                        icon: serverState.Message.MessageType,
                        confirmButtonText: serverState.Message.ConfirmButtonText,
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        switch (serverState.Message.Action) {
                            case 'close':
                                if (handleRefresh)
                                    handleRefresh();
                                if (handleClose)
                                    handleClose();
                                break;
                            case 'none':
                                break;
                            case 'reload':
                                window.location.reload();
                                break;
                            case 'redirect':
                                window.location.replace(serverState.Message.ActionParam);
                                break;
                            default:
                                break;
                        }
                    });
                },
                10
            );
        }
    }, [serverState.Message])
    useEffect(() => {
        if (serverState.StateName !== undefined && serverState.StateName !== null) {
            setTimeout(
                function () {
                    if (setLocalState) {
                        setLocalState({ [serverState.StateName]: serverState.StateValue });
                    }
                },
                10
            );
        }
    }, [serverState.StateName])
    useEffect(() => {
        if (serverState.Notification !== undefined && serverState.Notification !== null) {
            setTimeout(
                function () {
                    enqueueSnackbar(serverState.Notification.Message, { variant: serverState.Notification.Variant })
                },
                10
            );
        }
    }, [serverState.Notification])
    useEffect(() => {
        if (serverState.ErrorField !== undefined) {
            const setFocus = (id) => {
                setTimeout(
                    function () {
                        scrollIntoView(id);
                        var el = document.getElementById(id);
                        if (el)
                            el.focus();

                    },
                    0
                );
            }
            const scrollIntoView = (name) => {
                scroll.scrollTo(name, {
                    duration: 0,
                    delay: 0,
                    smooth: true,
                    offset: -80, // Scrolls to element + 50 pixels down the page
                });
            }
            setTimeout(
                function () {
                    if (setLocalState) {
                        setLocalState({ ErrorField: serverState.ErrorField });
                        setLocalState({ ErrorText: serverState.ErrorMessage });
                        if (serverState.ErrorField !== '' && serverState.ErrorField !== null)
                            setFocus(serverState.ErrorField);
                    }
                },
                10
            );
        }
    }, [serverState.ErrorField])
    return (
        <>
        </>
    );
}